import { useEffect } from 'react'
import { reduce } from 'ramda'

import { api } from 'app/api'
import { GET_TRANSFER_SENDERS, convertResult as convertSenders } from 'app/common/api/requests/cabinet/cafeteria/payments/transfer/senders/get'
import { GET_TRANSFER_RECIPIENTS, convertResult as conveertRecipients, convertParams as conveertRecipientsParams } from 'app/common/api/requests/cabinet/cafeteria/payments/transfer/recipients/get'
import { SendersInfo } from 'app/dataTypes/transfer/senders'

import { sendersInfoParams, sendersInfo, recipientsInfo, defaultRecipientsInfo } from '../dataBox'


export function useTransferFetch() {
  useEffect(() => {
    if (!sendersInfo.init || !recipientsInfo.init) return () => { }
    sendersInfo.addDataReceiver(async () => {
      const res = await api.request(GET_TRANSFER_SENDERS, {
        error: 'Не удалось получить данные отправителей перевода средств',
        convertions: {
          convertResult: convertSenders,
        },
      })
      return res
    })

    recipientsInfo.addDataReceiver(async (senders: SendersInfo) => {
      const { activeSenders } = senders
      const res = await Promise.all(
        activeSenders.map(({ UID }) => api.request(GET_TRANSFER_RECIPIENTS, {
          error: 'Не удалось получить данные получателей перевода средств',
          params: {
            senderUID: UID,
          },
          convertions: {
            convertParams: conveertRecipientsParams,
            convertResult: conveertRecipients,
          },
        }))
      )

      const allRecipients = reduce((acc, val) => {
        if (val) {
          const { recipientsBySenderUID, activeRecipientsBySenderUID, hasActiveRecipients } = val
          acc.recipientsBySenderUID = {
            ...acc.recipientsBySenderUID,
            ...recipientsBySenderUID,
          }
          acc.activeRecipientsBySenderUID = {
            ...acc.activeRecipientsBySenderUID,
            ...activeRecipientsBySenderUID,
          }
          acc.hasActiveRecipients = acc.hasActiveRecipients || hasActiveRecipients
        }
        return acc
      }, { ...defaultRecipientsInfo }, res)

      return allRecipients
    })

    const unsubsribeSenders = sendersInfoParams.subscribeDataBox(sendersInfo)
    const unsubsribeRecipients = sendersInfo.subscribeDataBox(recipientsInfo)
    sendersInfoParams.updateData(() => ({}))

    return () => {
      unsubsribeRecipients()
      unsubsribeSenders()
      recipientsInfo.resetToDefault()
      sendersInfo.resetToDefault()
      sendersInfoParams.resetToDefault()
    }
  }, [])
}
